enum PersonNameRequirementOption {
  NONE_REQUIRED = "personNameNoneRequired",
  ALL_REQUIRED = "personNameAllRequired",
  FIRST_NAME_REQUIRED = "personNameFirstNameRequired",
  LAST_NAME_REQUIRED = "personNameLastNameRequired",
}

export default PersonNameRequirementOption;
